import { useEffect } from 'react';

const defaultMeta = {
  title: 'a.gpt | AI Business Coach',
  description: 'Dea - Your AI-powered business coach. Build the business and life you\'ve been dreaming of with personalized daily coaching, 90-day transformation journeys, and cycle-synced productivity.',
  image: '/images/ambition-gpt-logo.png',
  url: 'https://beambitious.chat'
};

export default function SEO({ 
  title, 
  description, 
  image,
  noindex = false 
}) {
  const seoTitle = title ? `${title} | a.gpt` : defaultMeta.title;
  const seoDescription = description || defaultMeta.description;
  const seoImage = image || defaultMeta.image;

  useEffect(() => {
    // Set page title
    document.title = seoTitle;
    
    // Update meta tags
    const updateMeta = (name, content, property = false) => {
      const attr = property ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attr}="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute(attr, name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    updateMeta('description', seoDescription);
    updateMeta('og:type', 'website', true);
    updateMeta('og:title', seoTitle, true);
    updateMeta('og:description', seoDescription, true);
    updateMeta('og:image', seoImage, true);
    updateMeta('og:url', defaultMeta.url, true);
    updateMeta('twitter:card', 'summary_large_image');
    updateMeta('twitter:title', seoTitle);
    updateMeta('twitter:description', seoDescription);
    updateMeta('twitter:image', seoImage);

    // Handle noindex
    let robotsMeta = document.querySelector('meta[name="robots"]');
    if (noindex) {
      if (!robotsMeta) {
        robotsMeta = document.createElement('meta');
        robotsMeta.setAttribute('name', 'robots');
        document.head.appendChild(robotsMeta);
      }
      robotsMeta.setAttribute('content', 'noindex, nofollow');
    } else if (robotsMeta) {
      robotsMeta.remove();
    }

    return () => {
      // Cleanup on unmount - reset to default
      document.title = defaultMeta.title;
    };
  }, [seoTitle, seoDescription, seoImage, noindex]);

  return null;
}
